module.exports = __webpack_public_path__ + "img/art-15.105a8b6f.png";